export enum PublicTypes {
  All = 0,
  Public = 1,
  Private = 2,
}

export function getPublicTypeName(value: PublicTypes): string {
  switch (value) {
    case PublicTypes.All: return 'すべて';
    case PublicTypes.Public: return '公開';
    case PublicTypes.Private: return '未公開';
  }
}
